export function isControlUrl(host = window.location.host) {
  const idControlHostRegex = /^id(\.dev)?\.control\.accedo\.tv$/;
  return idControlHostRegex.test(host);
}



// WEBPACK FOOTER //
// ./src/client/src/utils/url.js